<div class="row">
    <div class="col col-12">
        <app-header />
    </div>
</div>
<div
  tuiCardLarge
  tuiSurface="elevated"
>
    <div class="row">
        <div class="col col-12">
            <div class="row">
                <div class="col col-12">
                  <form [formGroup]="searchForm" (ngSubmit)="onSubmitForm()">
                    <div class="row">
                        <div class="col col-6">
                          <tui-input formControlName="nir">
                              NIR
                              <input tuiTextfieldLegacy />
                          </tui-input>
                        </div>

                        <div class="col col-6">
                          <tui-input formControlName="nomPrenom">
                              Nom patient
                              <input tuiTextfieldLegacy />
                          </tui-input>
                          <button size="m" tuiButton style="display: none;">OK</button>
                        </div>
                      </div>
                    </form>

                    <div class="row">
                      <div class="col col-12">
                        <app-prescription-form-list [nomPrenom]="nomPrenom0()" [nir]="nir0()"/>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
